export function emitModel(component, value) {
    component.$emit("update:modelValue", value);
}
